import EntityDisplay from '@src/design-system/molecules/ticlick-table/table-cells/entity-display';
import { createColumnHelper } from '@tanstack/react-table';
import { StatusCell } from './components/status-cell';
import { formatDate } from '@shared/utils/helpers/format-date';
import { People } from 'iconsax-react';
import { object, string } from 'yup';
import { isValidPhoneNumber } from 'react-phone-number-input';
import type { TLead } from '@shared/types/lead';

const columnHelper = createColumnHelper<TLead['programs'][number]>();

export const leadProgramsColumn = [
  columnHelper.accessor('name', {
    id: 'program',
    header: 'Program',
    cell: ({ row, getValue }) => {
      const sub = `#${row.original.formatted_sharable_uid}`;
      return (
        <EntityDisplay
          main={getValue()}
          sub={sub}
        />
      );
    },
  }),
  columnHelper.accessor('status', {
    id: 'status',
    cell: ({ row }) => (
      <div className='max-w-28'>
        <StatusCell program={row.original} />
      </div>
    ),
    header: 'Status',
  }),
  columnHelper.accessor('start_date', {
    id: 'start_date',
    cell: ({ row }) =>
      row.original.start_date ? formatDate(row.original.start_date) : '-',
    header: 'Start Date',
  }),
  columnHelper.accessor('deadline', {
    id: 'end_date',
    cell: ({ row }) =>
      row.original.deadline ? formatDate(row.original.deadline) : '-',
    header: 'End Date',
  }),
  columnHelper.accessor('no_stages', {
    id: 'stages_number',
    cell: ({ row }) => row.original.no_stages ?? 0,
    header: 'Stages Number',
  }),
  columnHelper.accessor('no_responses', {
    id: 'responses',
    cell: ({ row }) => (
      <div className='bg-secondary-100 border border-secondary-200 rounded-xl p-2 text-secondary-1000 flex gap-2 items-center w-auto max-w-16 justify-center'>
        <span>{row.original.no_responses ?? 0}</span> <People size='16' />
      </div>
    ),
    header: 'Responses',
  }),
];

export const editPersonalInfoSchema = object({
  first_name: string().required('First Name is required'),
  last_name: string().required('Last Name is required'),
  email: string().email().required('Email is required'),
});

export const editMainInfoSchema = object({
  name: string().required('Full Name is required'),
  email: string().email().required('Email is required'),
  phone_number: string()
    .required('Phone is required')
    .test(
      'primary_phone_number',
      'Please enter a valid phone number',
      (value) => {
        return isValidPhoneNumber(value);
      }
    ),
  whatsapp_number: string().test(
    'whatsapp_number',
    'Please enter a valid phone number',
    (value) => {
      return value ? isValidPhoneNumber(value) : true;
    }
  ),
});
